export const isDev = () =>
  process.env.NODE_ENV === "development" ||
  process.env.NEXT_PUBLIC_ENVIRONMENT === "development";

export const isPreview = () =>
  process.env.NEXT_PUBLIC_ENVIRONMENT === "preview";

export const isProd = () =>
  process.env.NEXT_PUBLIC_ENVIRONMENT === "production";
